import { Button, Result } from "antd";
import useNavigateTo from "../../../hooks/useNavigateTo";
import AuthContainerItem from "./../../authContainer/authContainerItem";
const SuccessResetPassword = () => {
    let navigateTo = useNavigateTo();

    const handleClick = () => navigateTo("/login");
    return (
        <AuthContainerItem className='forgotPassword-form-success'>
            <Result
                status='success'
                title='Contraseña modificada'
                subTitle={`El usuario fue modificado correctamente con la nueva contraseña`}
                extra={
                    <Button type='primary' onClick={handleClick}>
                        Volver al Login
                    </Button>
                }
            />
        </AuthContainerItem>
    );
};
export default SuccessResetPassword;
